export enum MUTATION_KEYS {
  CALCULATE_CONVERSION_FEE = 'calculateConversionFee',
  SEND_CONVERT_OR_SELL = 'sendConvertOrSell',
  SHARES_BUY_STOCK = 'sharesBuyStock',
  SHARES_SELL_STOCK = 'sharesSellStock',
  SHARES_GET_QUOTES = 'sharesGetQuotes',
}
